import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { AvisoService } from '../../../services/aviso/aviso.service';
import { finalize, lastValueFrom } from 'rxjs';
import { AvisoView } from '../../../models/AvisoView';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotificationService } from '../../../services/notification/notification.service';

@Component({
  selector: 'app-avisos-view-details',
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule],
  templateUrl: './avisos-view-details.component.html',
  styleUrl: './avisos-view-details.component.scss',
})
export class AvisosViewDetailsComponent implements OnInit {
  allAvisos: AvisoView[] = [];
  clickedAviso!: AvisoView;
  total = 0;
  currentIndex = 0;
  public isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AvisosViewDetailsComponent>,
    private avisoService: AvisoService,
    private notificacaoService: NotificationService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.clickedAviso = this.data.avisoClicado;
    this.loadAvisos();
  }
  next(): void {
    if (this.currentIndex < this.total - 1) {
      this.currentIndex++;
      this.updateCurrentAviso();
    }
  }

  previous(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateCurrentAviso();
    }
  }

  private updateCurrentAviso(): void {
    this.clickedAviso = this.allAvisos[this.currentIndex];
    const jaEstavaVisualizado =
      this.clickedAviso.status?.toLowerCase() === 'visualizado';

    if (!jaEstavaVisualizado) {
      this.avisoService.visualizarAviso(this.clickedAviso.id).subscribe({
        next: () => {
          this.clickedAviso.status = 'visualizado';
          this.notificacaoService.handleAvisoVisualized()
        },
        error: (err) => {
          console.error('Erro ao marcar aviso como visualizado', err);
        },
      });
    }
  }

  async loadAvisos() {
    try {
      this.isLoading = false;

      // Recebe os avisos passados pelo componente pai
      this.allAvisos = this.data.avisos.map((aviso: any) => {
        return {
          ...aviso,
        };
      });

      this.total = this.allAvisos.length;

      // Encontra o índice do aviso clicado na lista completa
      this.findAvisoIndex();

      if (this.currentIndex === -1) {
        this.currentIndex = 0;
        this.clickedAviso = this.allAvisos[0];
      }
    } catch (err) {
      console.error('Falha ao buscar os avisos:', err);
    }
  }

  private findAvisoIndex(): void {
    if (this.clickedAviso && this.allAvisos.length > 0) {
      const foundIndex = this.allAvisos.findIndex(
        (aviso) => aviso.id === this.clickedAviso.id
      );

      if (foundIndex !== -1) {
        this.currentIndex = foundIndex;
        this.clickedAviso = this.allAvisos[foundIndex];
      } else {
        this.currentIndex = 0;
        this.clickedAviso = this.allAvisos[0];
      }
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
